export default "__VITE_ASSET__18933ec0__"